import { render, staticRenderFns } from "./LotesList.vue?vue&type=template&id=2dc4d852"
import script from "./LotesList.vue?vue&type=script&lang=js"
export * from "./LotesList.vue?vue&type=script&lang=js"
import style0 from "./LotesList.vue?vue&type=style&index=0&id=2dc4d852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports